import React from 'react';
import WorkforceInviteSvg from './assets/WorkforceInvite.svg';
import { ImageProps } from './interface';

export function WorkforceInviteImage(props: ImageProps) {
  return <WorkforceInviteSvg {...props} />;
}
